var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"styled-description",class:{ compact: _vm.compact, inline: _vm.inline },domProps:{"innerHTML":_vm._s(_vm.markup(_vm.description))}})
}
var staticRenderFns = []

export { render, staticRenderFns }